/**
 * cacheMonitoringTabStyles.js — StyleSheet for CacheMonitoringTab.
 * Extracted verbatim from components/CacheMonitoringTab.jsx (god-file decomposition).
 */

import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0F172A',
  },
  centerContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    color: '#94A3B8',
    fontSize: 16,
    marginTop: 16,
  },
  errorTitle: {
    color: '#EF4444',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  errorMessage: {
    color: '#94A3B8',
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#8B5CF6',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  retryButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  header: {
    padding: 20,
    paddingBottom: 12,
  },
  title: {
    color: '#FFFFFF',
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  subtitle: {
    color: '#94A3B8',
    fontSize: 14,
  },
  
  // ⭐ Info Card Styles
  infoCard: {
    backgroundColor: '#1E293B',
    borderRadius: 12,
    padding: 16,
    marginHorizontal: 16,
    marginBottom: 16,
    borderLeftWidth: 4,
    borderLeftColor: '#8B5CF6',
  },
  infoTitle: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  infoText: {
    color: '#CBD5E1',
    fontSize: 14,
    lineHeight: 20,
  },
  infoBold: {
    fontWeight: '700',
    color: '#FFFFFF',
  },
  infoList: {
    marginTop: 12,
    marginBottom: 12,
  },
  infoListItem: {
    color: '#CBD5E1',
    fontSize: 13,
    lineHeight: 22,
    marginBottom: 6,
  },
  infoEmoji: {
    fontSize: 14,
  },
  infoFooter: {
    color: '#94A3B8',
    fontSize: 12,
    fontStyle: 'italic',
    marginTop: 8,
  },
  
  actionsCard: {
    marginHorizontal: 16,
    marginBottom: 16,
    gap: 12,
  },
  actionButton: {
    backgroundColor: '#8B5CF6',
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 50,
  },
  actionButtonDisabled: {
    backgroundColor: '#64748B',
  },
  actionButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  countdownContainer: {
    alignItems: 'center',
    paddingVertical: 16,
  },
  countdownText: {
    color: '#8B5CF6',
    fontSize: 36,
    fontWeight: 'bold',
    fontVariant: ['tabular-nums'],
  },
  countdownSubtext: {
    color: '#94A3B8',
    fontSize: 14,
    marginTop: 4,
  },
  card: {
    backgroundColor: '#1E293B',
    marginHorizontal: 16,
    marginBottom: 16,
    padding: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#334155',
  },
  cardTitle: {
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 12,
  },
  healthBadge: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  healthText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  statRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  statLabel: {
    color: '#94A3B8',
    fontSize: 14,
  },
  statValue: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  footer: {
    padding: 20,
    alignItems: 'center',
  },
  footerText: {
    color: '#64748B',
    fontSize: 12,
    fontStyle: 'italic',
  },
  
  // Modal styles
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#1E293B',
    width: '90%',
    maxHeight: '80%',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#334155',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
  },
  modalTitle: {
    color: '#FFFFFF',
    fontSize: 22,
    fontWeight: 'bold',
  },
  modalClose: {
    color: '#94A3B8',
    fontSize: 28,
    fontWeight: 'bold',
  },
  modalBody: {
    padding: 16,
  },
  
  // Log styles
  logEntry: {
    backgroundColor: '#0F172A',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#10B981',
  },
  logEntryError: {
    borderLeftColor: '#EF4444',
  },
  logTimestamp: {
    color: '#64748B',
    fontSize: 12,
    marginBottom: 4,
  },
  logType: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  logTypeSuccess: {
    color: '#10B981',
  },
  logTypeError: {
    color: '#EF4444',
  },
  logMessage: {
    color: '#FFFFFF',
    fontSize: 14,
    marginBottom: 4,
  },
  logStats: {
    color: '#94A3B8',
    fontSize: 12,
    marginTop: 4,
  },
  logStack: {
    color: '#EF4444',
    fontSize: 10,
    marginTop: 8,
    fontFamily: 'monospace',
  },
  noLogsText: {
    color: '#94A3B8',
    fontSize: 16,
    textAlign: 'center',
    paddingVertical: 40,
  },
  
  // Fixture browser styles
  filtersRow: {
    flexDirection: 'row',
    padding: 16,
    gap: 8,
    flexWrap: 'wrap',
  },
  filterButton: {
    backgroundColor: '#334155',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  filterButtonActive: {
    backgroundColor: '#8B5CF6',
  },
  filterButtonText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  fixtureCard: {
    backgroundColor: '#0F172A',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#334155',
  },
  fixtureHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  fixtureLeague: {
    color: '#8B5CF6',
    fontSize: 12,
    fontWeight: 'bold',
  },
  fixtureDate: {
    color: '#64748B',
    fontSize: 11,
  },
  fixtureMatchup: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 8,
  },
  fixtureStatsRow: {
    flexDirection: 'row',
    gap: 16,
  },
  fixtureStatText: {
    color: '#94A3B8',
    fontSize: 12,
  },
  fixtureCardNoOdds: {
    borderColor: '#F59E0B',
    backgroundColor: '#1F2937',
    opacity: 0.8,
  },
  hasOddsBadge: {
    backgroundColor: '#10B98120',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#10B981',
  },
  hasOddsBadgeText: {
    color: '#10B981',
    fontSize: 10,
    fontWeight: 'bold',
  },
  noOddsBadge: {
    backgroundColor: '#F59E0B20',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#F59E0B',
  },
  noOddsBadgeText: {
    color: '#F59E0B',
    fontSize: 10,
    fontWeight: 'bold',
  },
  fixtureNoOddsText: {
    color: '#F59E0B',
    fontSize: 12,
    fontStyle: 'italic',
    marginTop: 4,
  },
  liveFixtureItemNoOdds: {
    borderColor: '#F59E0B',
    backgroundColor: '#1F293B',
    opacity: 0.85,
  },
  liveOddsStatus: {
    color: '#10B981',
    fontSize: 14,
    fontWeight: 'bold',
  },
  liveNoOddsStatus: {
    color: '#F59E0B',
    fontSize: 14,
  },
  expandIcon: {
    color: '#8B5CF6',
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 8,
  },
  noFixturesText: {
    color: '#94A3B8',
    fontSize: 16,
    textAlign: 'center',
    paddingVertical: 40,
  },
  
  // Expanded markets styles
  expandedSection: {
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#334155',
  },
  expandedHeader: {
    marginBottom: 12,
  },
  expandedTitle: {
    color: '#8B5CF6',
    fontSize: 14,
    fontWeight: 'bold',
  },
  marketSection: {
    marginBottom: 16,
    backgroundColor: '#1E293B',
    padding: 12,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#8B5CF6',
  },
  marketHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
  },
  marketName: {
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: '600',
    flex: 1,
  },
  marketCount: {
    color: '#8B5CF6',
    fontSize: 11,
    fontWeight: 'bold',
  },
  oddRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
  },
  oddLeft: {
    flex: 1,
  },
  oddRight: {
    alignItems: 'flex-end',
    marginLeft: 12,
  },
  oddSelection: {
    color: '#F1F5F9',
    fontSize: 13,
    fontWeight: '500',
    marginBottom: 4,
  },
  oddSportsbook: {
    color: '#64748B',
    fontSize: 11,
  },
  oddPrice: {
    color: '#10B981',
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  oddEV: {
    fontSize: 10,
    fontWeight: '600',
  },
  oddEVPositive: {
    color: '#10B981',
  },
  oddEVNegative: {
    color: '#EF4444',
  },
  moreOddsText: {
    color: '#64748B',
    fontSize: 11,
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: 8,
  },
  
  // Live Monitor styles
  liveMonitorContent: {
    height: '90%',
    maxHeight: 800,
  },
  liveMonitorHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  liveProgressSummary: {
    backgroundColor: '#1E293B',
    padding: 16,
    borderRadius: 8,
    marginBottom: 16,
    borderLeftWidth: 4,
    borderLeftColor: '#10B981',
  },
  liveProgressText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  liveProgressStats: {
    color: '#94A3B8',
    fontSize: 14,
    marginBottom: 6,
  },
  liveProgressBreakdown: {
    marginTop: 8,
  },
  liveProgressSplit: {
    flexDirection: 'row',
    gap: 16,
    marginVertical: 8,
  },
  liveProgressSubStat: {
    fontSize: 13,
    fontWeight: '600',
  },
  liveTerminal: {
    flex: 1,
    backgroundColor: '#000000',
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#334155',
  },
  terminalHeader: {
    backgroundColor: '#1E293B',
    paddingVertical: 8,
    paddingHorizontal: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
  },
  terminalTitle: {
    color: '#10B981',
    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 1,
  },
  terminalSubtitle: {
    color: '#64748B',
    fontSize: 10,
  },
  terminalBody: {
    flex: 1,
    padding: 12,
  },
  terminalBodyContent: {
    paddingBottom: 20,
  },
  terminalLogBlock: {
    marginBottom: 8,
  },
  terminalLine: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 2,
  },
  terminalTimestamp: {
    color: '#64748B',
    fontSize: 12,
    fontFamily: 'monospace',
    marginRight: 8,
  },
  terminalMessage: {
    color: '#FFFFFF',
    fontSize: 13,
    fontFamily: 'monospace',
    flex: 1,
  },
  terminalError: {
    color: '#EF4444',
  },
  terminalSuccess: {
    color: '#10B981',
  },
  terminalInfo: {
    color: '#3B82F6',
  },
  terminalStats: {
    color: '#8B5CF6',
    fontSize: 11,
    fontFamily: 'monospace',
    marginLeft: 80,
    marginTop: 2,
  },
  liveMonitorActions: {
    paddingTop: 16,
    alignItems: 'center',
  },
  liveActionButton: {
    backgroundColor: '#10B981',
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 8,
    minWidth: 200,
    alignItems: 'center',
  },
  liveActionButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  liveMonitorNote: {
    color: '#94A3B8',
    fontSize: 13,
    textAlign: 'center',
    fontStyle: 'italic',
  },
  
  // Live fixture tracking styles
  liveCounterContainer: {
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#334155',
  },
  liveCounterText: {
    color: '#10B981',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  liveFixturesPanel: {
    backgroundColor: '#0F172A',
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#334155',
    maxHeight: 300,
  },
  liveFixturesTitle: {
    color: '#8B5CF6',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  liveFixturesList: {
    maxHeight: 250,
  },
  liveFixtureItem: {
    backgroundColor: '#1E293B',
    padding: 10,
    borderRadius: 6,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#10B981',
  },
  liveFixtureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  liveFixtureLeague: {
    color: '#8B5CF6',
    fontSize: 11,
    fontWeight: 'bold',
  },
  liveFixtureTime: {
    color: '#64748B',
    fontSize: 10,
  },
  liveFixtureMatchup: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 4,
  },
  liveFixtureMarkets: {
    color: '#10B981',
    fontSize: 11,
  },
  
  // Split Button Styles
  splitButtonWrapper: {
    marginBottom: 12,
  },
  splitButtonContainer: {
    flexDirection: 'row',
  },
  splitButtonMain: {
    flex: 1,
    backgroundColor: '#8B5CF6',
    paddingVertical: 14,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    alignItems: 'center',
  },
  splitButtonDropdown: {
    backgroundColor: '#7C3AED',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    borderLeftWidth: 1,
    borderLeftColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownArrow: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
  dropdownMenu: {
    backgroundColor: '#1E293B',
    borderRadius: 8,
    marginTop: 4,
    borderWidth: 1,
    borderColor: '#334155',
    overflow: 'hidden',
  },
  dropdownItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
  },
  dropdownItemHighlight: {
    backgroundColor: '#8B5CF620',
    borderBottomWidth: 0,
  },
  dropdownItemText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '500',
  },
  dropdownItemTextHighlight: {
    color: '#8B5CF6',
    fontWeight: '700',
  },
  
  // Browse Odds Styles
  cardSubtitle: {
    color: '#64748B',
    fontSize: 13,
    marginBottom: 16,
    marginTop: 4,
  },
  browseOddsButton: {
    backgroundColor: '#8B5CF6',
    paddingVertical: 14,
    borderRadius: 8,
    alignItems: 'center',
    marginBottom: 12,
  },
  browseOddsButtonText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: 'bold',
  },
  browseOddsHint: {
    color: '#64748B',
    fontSize: 12,
    fontStyle: 'italic',
    textAlign: 'center',
  },
  
  // ⭐ Cache Breakdown Styles (Dual-Endpoint Strategy)
  cacheBreakdownContainer: {
    marginTop: 12,
  },
  cacheBreakdownSection: {
    marginBottom: 12,
  },
  cacheBreakdownLabel: {
    color: '#94A3B8',
    fontSize: 12,
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 8,
  },
  cacheBreakdownValue: {
    color: '#FFFFFF',
    fontSize: 36,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  cacheBreakdownSplit: {
    flexDirection: 'row',
    gap: 16,
  },
  cacheBreakdownItem: {
    flex: 1,
    backgroundColor: '#1E293B',
    padding: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cacheBreakdownSubValue: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  cacheBreakdownSubLabel: {
    color: '#94A3B8',
    fontSize: 11,
    textAlign: 'center',
  },
  
  // ⭐ League Breakdown Styles
  leagueRow: {
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#1E293B',
  },
  leagueHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leagueLabel: {
    color: '#E2E8F0',
    fontSize: 16,
    fontWeight: '600',
  },
  leagueCount: {
    color: '#8B5CF6',
    fontSize: 16,
    fontWeight: 'bold',
  },
  
  // ⭐ Phase Breakdown Styles
  phaseContainer: {
    marginTop: 16,
    gap: 16,
  },
  phaseItem: {
    backgroundColor: '#1E293B',
    padding: 14,
    borderRadius: 10,
    borderLeftWidth: 3,
    borderLeftColor: '#8B5CF6',
  },
  phaseLabel: {
    color: '#8B5CF6',
    fontSize: 12,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 4,
  },
  phaseDesc: {
    color: '#94A3B8',
    fontSize: 12,
    marginBottom: 6,
  },
  phaseValue: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '600',
  },
  phaseBreakdown: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 6,
  },
  phaseSubValue: {
    fontSize: 13,
    fontWeight: '600',
  },
  
  // ⭐ NEW: Sample Data Styles
  divider: {
    height: 1,
    backgroundColor: '#1E293B',
    marginVertical: 16,
  },
  sampleDataTitle: {
    color: '#E2E8F0',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  marketTagsContainer: {
    flexDirection: 'row',
    marginBottom: 8,
    maxHeight: 40,
  },
  marketTag: {
    backgroundColor: '#1E293B',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#334155',
  },
  marketTagText: {
    color: '#94A3B8',
    fontSize: 12,
    fontWeight: '500',
  },
  sampleOddsContainer: {
    maxHeight: 400,
  },
  sampleOddsItem: {
    backgroundColor: '#1E293B',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#334155',
  },
  sampleFixture: {
    color: '#E2E8F0',
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 6,
  },
  sampleMarket: {
    color: '#8B5CF6',
    fontSize: 12,
    fontWeight: '600',
    marginBottom: 8,
  },
  oddRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: '#0F172A',
    borderRadius: 4,
    marginBottom: 4,
  },
  oddSelection: {
    color: '#CBD5E1',
    fontSize: 12,
    flex: 2,
  },
  oddPrice: {
    color: '#10B981',
    fontSize: 12,
    fontWeight: 'bold',
    flex: 1,
    textAlign: 'center',
  },
  oddSportsbook: {
    color: '#64748B',
    fontSize: 11,
    flex: 1,
    textAlign: 'right',
  },
  oddEV: {
    color: '#F59E0B',
    fontSize: 10,
    fontWeight: '600',
    marginLeft: 8,
  },
});
